import { createContext } from "react";
import { UserModalContextInterface } from "../../Interfaces/ContextInterfaces/UserModalContextInterface";

const UserModalContext = createContext<UserModalContextInterface | undefined>(undefined)

export default UserModalContext